import React from "react";
import moment from "moment";
import { FiActivity } from "react-icons/fi";

import Config from "../../Config";
import {
  ModalContainer,
  ModalContent,
  ScrollableContent,
} from "../Styles/InputStyles";
import DrawerHeader from "./DrawerHeader";


const ActivityLogsModal = ({
  onClose,
  logs = [],
}) => {
  const activities = Array.isArray(logs) ? logs : [];

  const groupedActivities = activities.reduce(
    (acc, item) => {
      const date = moment(item.createdAt).format("DD MMM YYYY");

      if (!acc[date]) {
        acc[date] = [];
      }

      acc[date].push(item);

      return acc;
    },
    {}
  );

  return (
    <ModalContainer>
      <DrawerHeader
        title="Recent Activity"
        subtitle="Operational activity logs"
        icon={<FiActivity />}
        onClose={onClose}
      />

      <ModalContent className="py-2">
        <ScrollableContent className="max-h-[calc(100dvh-100px)] ">

          {activities.length === 0 ? (
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <FiActivity className="text-5xl text-gray-300" />

              <p className="mt-4 text-sm text-gray-500">
                No activity found
              </p>
            </div>
          ) : (
            <div className="px-6 space-y-8 mt-4">

              {Object.entries(groupedActivities).map(
                ([date, items]) => (
                  <div key={date}>

                    {/* Date */}
                    <div className="sticky top-0 z-10 bg-white py-2">
                      <span className="text-xs font-semibold tracking-wide uppercase text-gray-400">
                        {date}
                      </span>
                    </div>

                    {/* Timeline */}
                    <div className="space-y-5 mt-3">

                      {items.map((item, index) => (
                        <div
                          key={item.id || index}
                          className="flex gap-4"
                        >

                          {/* Timeline Dot */}
                          <div className="relative">
                            <div
                              className="
                                w-2.5 h-2.5 rounded-full
                                bg-[#0078BD] mt-2
                              "
                            />

                            <div
                              className="
                                absolute left-[4px]
                                top-5 bottom-[-30px]
                                w-px bg-gray-200
                              "
                            />
                          </div>

                          {/* Activity */}
                          <div className="flex-1 pb-2">

                            <div
                              className="
                                bg-[#F8FAFC]
                                rounded-2xl p-4
                              "
                            >

                              <p className="text-[13px] text-gray-800 leading-relaxed">
                                <span className="font-semibold">
                                  {item?.doneByName || "--"}
                                </span>{" "}

                                {item?.description || "--"}
                              </p>

                              <div
                                className="
                                  flex items-center gap-2
                                  mt-2 text-xs text-gray-500
                                "
                              >
                                <span className="text-[11px]">
                                {item?.device === 1
                                    ? "Android"
                                    : item?.device === 2
                                    ? "iOS"
                                    : item?.device === 3
                                    ? "Web"
                                    : ""}
                                </span>

                                <span className="text-[9px]">•</span>

                                <span className="text-[11px]">
                                  {moment(
                                    item.createdAt
                                  ).fromNow()}
                                </span>
                              </div>

                            </div>

                          </div>
                        </div>
                      ))}

                    </div>
                  </div>
                )
              )}

            </div>
          )}

        </ScrollableContent>
      </ModalContent>
    </ModalContainer>
  );
};

export default ActivityLogsModal;
